export default "__VITE_ASSET__DY95XO6D__"